import {interactFields} from './Interact';
import {pseudoFields} from './Pseudo';
import {spacialFields} from './Spacial';
import {textFields} from './Text';
import {visualFields} from './Visual';

export type FieldsType = {
    [key in typeof fields[number]]?: any;
};

export const fields: Array<string> = ([
    ...interactFields,
    ...pseudoFields,
    ...spacialFields,
    ...textFields,
    ...visualFields,
] as string[]) // TODO https://github.com/microsoft/TypeScript/issues/36769
